import styles from './Header.module.scss';
import React from 'react';
import Logo from '../../../shared/Logo/Logo';
import LanguageSelector from '../../../shared/LanguageSelector/LanguageSelector';

export default function Header() {
    return (
        <div className={styles.header}>
            <Logo />
            <LanguageSelector />
        </div>
    );
}
